import React, { useState } from "react";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { ReactComponent as PaperIcon } from "../../assets/imgs/icons/open_paper.svg";
import { SnippetList } from "./SnippetList";
import { Theme, makeStyles, createStyles } from "@material-ui/core";
import { IArticle } from "../../core/redux/dataMap/article";

interface IArticlePaperModalProps {
  article: IArticle;
}

export const ArticlePaperModal: React.FC<IArticlePaperModalProps> = ({
  article,
}) => {
  const [isArticlePaperOpen, setOpenArticlePaper] = useState(false);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={isArticlePaperOpen ? "button" : "snippets"}
          addEndListener={(node, done) =>
            node.addEventListener("transitionend", done, false)
          }
          classNames="fade"
        >
          {isArticlePaperOpen ? (
            <SnippetList
              article={article}
              closePaper={() => setOpenArticlePaper(false)}
            />
          ) : (
            <div
              onClick={() => setOpenArticlePaper(true)}
              className={classes.iconContainer}
            >
              <PaperIcon />
            </div>
          )}
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      boxSizing: "border-box",
      float: "right",
      position: "relative",
      color: "#00B0FF",
      fontSize: "35pt",
      textAlign: "center",
      backgroundColor: "whitesmoke",
    },
    iconContainer: {
      height: "100%",
      padding: "15px 18px 15px 15px",
      backgroundColor: "whitesmoke",
    },
  })
);
